import { loadFency } from "@fencyai/js";
import { requireStringEnvVar } from "../../config";

export const fencyPromise = loadFency({
  publishableKey: requireStringEnvVar("VITE_FENCY_PUBLISHABLE_KEY"),
});
